export enum ELanguage {
  en = 'en',
  de = 'de',
}

export type TNil = undefined | null;

export interface IHealthStatus {
  status: 'UP' | 'DOWN';
  app: string;
  env: string;
  date: string;
  maintenance: string;
  campaignVersion: string;
}
